export const environment = {
  production: true,
  enableAuthGuard: true,
  current_user: null,
  baseUrl: 'https://api.awaken180weightloss.com/api',
  // baseUrl: 'https://api.awaken180weightlossforlife.com/api',
  client_facing_app_url: 'https://client-api.awaken180weightloss.com/api/v1/internal_controllers',
  emojiApiKey: 'e994e0b7cbd3383a7a8b787e47ceef7d2184c741',
  esignGenieSecret: 'e8aa88706646e4d610602f6f513db2b6',
  teamFacingApiKey: 'af6d39b0239a94d1c16adbc65afd100249b2cc1f7bc05f10accd71a9a2171631'
};
